import { styled, TableCell as MuiTableCell, Typography } from '@mui/material';

export const TableTitleCell = styled(MuiTableCell)(({ theme }) => ({
  backgroundColor: theme.palette.grey[500],
  padding: '10px 16px',
}));

export const TableTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.black.main,
  fontStyle: 'italic',
}));
